import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CdsColorBackgroundWhiteMain, CdsColorBrandNeutral99 } from '@cegid/design-tokens';

export const useStyles = makeStyles((theme: Theme) => ({
  accessRightsPageLayout: {
    margin: `-${theme.spacing(4)} -${theme.spacing(3)} 0px -${theme.spacing(3)}`
  },
  accessRightsTopSection: {
    position: 'fixed',
    width: '100%',
    zIndex: theme.zIndex.drawer - 1,
    background: CdsColorBackgroundWhiteMain,
    left: 0,
  },
  accessRightsRequestsPageTitle: {
    display: 'flex',
    justifyContent: 'center',
    padding: '2em',
    position: 'relative',
    borderTop: `1px solid ${CdsColorBrandNeutral99}`,
    borderBottom: `1px solid ${CdsColorBrandNeutral99}`,
    width: '100%',
  },
  accessRightsCardsContainer: {
    margin: '1em',
    position: 'relative',
  }
}));
